import { ProviderDataType } from "@/api/ProviderApi";
import { ProviderRelatedAttributes } from "@/formTypes/ProviderFormDataType";
import { buildImportPayload as buildPayload } from "./core/payload";
import { ImportAction, ImportPayloadRow } from "./core/types";
import { ResolvedRow } from "./resolveProviderRows";

export type { ImportAction, ImportPayloadRow };

/**
 * Atributos que no viajan a la lambda: son relaciones que el formulario carga para
 * mostrar, no columnas del modelo.
 */
const RELATION_ATTRIBUTES = new Set<string>(ProviderRelatedAttributes as string[]);

/** Convierte las filas resueltas en el payload que espera la lambda de importacion. */
export const buildProviderImportPayload = (rows: ResolvedRow[]): ImportPayloadRow[] =>
    buildPayload<ProviderDataType & object>(rows, RELATION_ATTRIBUTES);
